import {
    queryGraphQL,
} from 'common/util/query';
import {
    toQuery,
    nodeWithArgs,
    node,
    enumeration,
} from 'common/util/queryHelper';

import {addApplicationMessage} from 'common/actions/applicationMessagesActions';

export const QUERY_FOR_DOCUMENTS = 'QUERY_FOR_DOCUMENTS';

export function loadFilesByQuery(queryParams) {
    const queryNodes = nodeWithArgs('queryDocuments', {
        queryParams: queryParams,
    }, [
        'id',
        'name',
        'documentStatus',
        'uploadDate',
        node('uploadUser', [
            'displayName',
            'emailAddress',
        ]),
        node('documentType', [
            'id',
            'displayName'
        ]),
        node('descriptors', [
            'id',
            'displayName',
        ]),
        nodeWithArgs('renditions', {
            type: enumeration('VIEW'),
        }, [
            'objectName',
            'containerId',
            'prettyFileName',
            'fileExt',
            'mimeType',
            'fileSize',
            'filePurpose',
            'createdDate',
        ]),
        node('signatures', [
            node('user', ['sub', 'name', 'emailAddress']),
            node('statement', ['id', 'name', 'statement']),
            'dateSigned'
        ])
    ]);

    return dispatch => {
        return queryGraphQL(toQuery(queryNodes)).then(results => {
            if (results.errors) {
                return Promise.reject('Failed to load documents. Please try again later.');
            }
            dispatch(queryForDocumentsAction(results.data.queryDocuments));
        }).catch(error => {
            dispatch(addApplicationMessage('error', 'An error has occurred when fetching documents. Please try again later.'));
        });
    };
}

export function queryForDocumentsAction(documents) {
    return {
        type: QUERY_FOR_DOCUMENTS,
        payload: {
            documents
        }
    };
}